<template>
  <div class="case_center">
    <div class="container">
      <el-card :body-style="{ padding: '12px 16px' }">
        <el-form>
          <el-form-item label="项目状况：">
            <div class="openInfo" :class="{ newClass: isShow }">
              <el-radio-group
                v-model="queryInfo.projectPhase"
                @change="
                  search()
                  resetPage()
                "
              >
                <el-radio-button label>不限</el-radio-button>
                <el-radio-button label="已完成"></el-radio-button>
                <el-radio-button label="已取消"></el-radio-button>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item label="工作地点：">
            <cascader-area
              :country="queryInfo.companyCountry"
              :province="queryInfo.companyProvince"
              :city="queryInfo.companyCity"
              @searchArae="searchArae"
              class="CascaderArea"
            />
          </el-form-item>
          <el-form-item label="所属行业："
            ><multi-select
              typeCode="004"
              @change="changePositionType"
              :code.sync="queryInfo.cilentIndustry"
          /></el-form-item>
          <el-form-item label="职位类型：">
            <multi-select
              typeCode="008"
              @change="changeoccupationType"
              :code.sync="queryInfo.occupationType"
            />
          </el-form-item>
          <el-form-item label="薪资范围：">
            <div class="money">
              <div class="left_money">
                <el-select
                  @change="
                    search()
                    resetPage()
                  "
                  style="width: 100px"
                  v-model="queryInfo.isAnnual"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in optionsMoney"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="right_money">
                <el-input
                  type="number"
                  @change="
                    search()
                    resetPage()
                  "
                  v-model="queryInfo.startSalaryRange"
                />
                <span>~</span>
                <el-input
                  type="number"
                  @change="
                    search()
                    resetPage()
                  "
                  v-model="queryInfo.endSalaryRange"
                />
              </div>
            </div>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card style="margin-top: 12px">
        <div class="case_center_seach">
          <el-input
            placeholder="请输入案例相关信息"
            v-model="queryInfo.queryConditions"
            class="input-with-select"
            clearable
          >
            <el-button slot="append" @click="search" icon="el-icon-search"></el-button>
          </el-input>
        </div>
        <el-table :data="tableData" ref="multipleTable" class="enterprise_table">
          <el-table-column label="序号" align="center" prop="id" />
          <el-table-column label="公司名称" align="center" prop="corporateName" />
          <el-table-column label="职位名称" align="center" prop="recruitmentPosition" />
          <el-table-column label="工作地点" align="center">
            <template v-slot="{ row }">
              <span
                v-if="
                  row.companyProvince != '北京' &&
                  row.companyProvince != '天津' &&
                  row.companyProvince != '上海' &&
                  row.companyProvince != '重庆'
                "
                >{{ row.companyCountry }}{{ row.companyProvince }}{{ row.companyCity }}</span
              >
              <span v-else>{{ row.companyCountry }}{{ row.companyProvince }}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属行业" align="center" prop="industry" />
          <el-table-column label="职位类型" align="center" prop="positionType" />
          <el-table-column label="薪资范围" align="center" prop="salaryRange" />
          <el-table-column label="沟通人数" align="center" prop="number" />
          <el-table-column label="推荐人数" align="center" prop="count" />
          <el-table-column label="offer薪资" align="center">
            <template v-slot="{ row }">
              <span v-if="row.annualSalary">{{ row.annualSalary }}/年</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column label="客户经理" align="center" prop="createName" />
          <el-table-column class="operation" width="100" label="操作" align="center">
            <template v-slot="{ row }">
              <div class="operation_bottom">
                <dic-button @buttonClick="seeItem(row)" icon="icon-jr-icon-earth" text="查看" />
                <dic-button @buttonClick="deleteItem(row)" icon="icon-jr-icon-delete" text="删除" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <div class="pagination">
      <el-pagination
        :current-page="queryInfo.baseParam.pageNum"
        :page-sizes="[30, 50, 100]"
        :page-size="queryInfo.baseParam.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
const defaultQueryInfo = Object.freeze({
  queryConditions: '', //案例相关信息
  cilentIndustry: [], // 所属行业
  companyCity: '', // 市
  companyCountry: '中国', //国家
  companyName: '', //公司名称
  companyProvince: '', //省
  baseParam: {
    pageNum: 1, //页数
    pageSize: 30 //大小
  },
  endSalaryRange: '', //结束薪资范围
  isAnnual: '', //月薪或者年薪0->月薪；1->年薪
  occupationType: [], //职业类型
  projectPhase: '', //项目状态
  startSalaryRange: '' //开始薪资范围
})
//planListPage
import { deletePlanByid, planListPage } from '@/api/caseCenter.js'
import DicButton from '../../../components/DicButton.vue'
import CascaderArea from '../../../components/CascaderArea.vue'
import MultiSelect from '../../../components/MultiSelect.vue'
export default {
  components: { DicButton, CascaderArea, MultiSelect },
  name: 'caseCenter',
  data() {
    return {
      total: 0,
      optionsMoney: [
        {
          value: 0,
          label: '月薪'
        },
        {
          value: 1,
          label: '年薪'
        }
      ],
      isShow: false,
      queryInfo: { ...defaultQueryInfo },
      tableData: [] //表格数据
    }
  },
  created() {
    // if (Object.keys(this.$store.state.queryInfo).length) {
    //   Object.keys(this.$store.state.queryInfo).forEach((item) => {
    //     this.queryInfo[item] = this.$store.state.queryInfo[item]
    //   })
    // }
    this.search()
  },
  methods: {
    // 条数
    handleSizeChange(newSize) {
      this.queryInfo.baseParam.pageSize = newSize
      this.search()
    },

    // 分页
    handleCurrentChange(newPage) {
      this.queryInfo.baseParam.pageNum = newPage
      this.search()
    },
    resetPage() {
      this.queryInfo.baseParam.pageSize = 30
      this.queryInfo.baseParam.pageNum = 1
    },
    //地点选择发射
    searchArae(val) {
      this.queryInfo.companyCountry = val.country

      this.queryInfo.companyProvince = val.province

      if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
        this.queryInfo.companyCity = val.city
      }
      this.resetPage()

      this.search()
    },
    //多选发射
    changePositionType(data) {
      this.queryInfo.cilentIndustry = data
      this.resetPage()
      this.search()
    },
    changeoccupationType(data) {
      this.queryInfo.occupationType = data
      this.resetPage()
      this.search()
    },
    //删除
    deleteItem(row) {
      this.$confirm('确认删除吗 ?', '提示')
        .then(async () => {
          const { data: res } = await deletePlanByid({ planById: row.id })
          if (res.resultCode == 200) {
            this.$message.success('删除成功')
            this.search()
          }
        })
        .catch(() => {})
    },
    //seeItem 点击进入详情
    seeItem(row) {
      this.$router.push({
        path: '/businessManagement/viewCaseInfo',
        query: {
          id: row.id,
          personnelId: row.personnelId,
          searchInfo: JSON.stringify(this.queryInfo)
        }
      })
    },
    //查询数据
    async search() {
      const { data: res } = await planListPage(this.queryInfo)
      if (res.resultCode === 200) {
        this.tableData = res.data.list
        this.total = res.data.total
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 82vh;
  overflow: scroll;
}
.pagination {
  width: 100%;
  text-align: center;
  margin: 10px 0 20px 0;
}
.case_center {
  /deep/.money .el-input__inner {
    height: 34px;
    line-height: 34px;
  }
  width: 100%;

  .el-table {
    /deep/tbody tr:hover > td {
      // background-color: #90c0f1;
      background-color: rgba(23, 117, 122, 0.1);
    }
  }

  .money {
    display: flex;
    flex-direction: row;
  }

  /deep/ input::-webkit-outer-spin-button,
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
  /deep/ input[type='number'] {
    -moz-appearance: textfield !important;
  }

  .right_money {
    display: flex;
    margin-left: 12px;
    flex-direction: row;
    align-items: center;
    /deep/ .el-input {
      width: 200px !important;
    }
    span {
      margin: 0 20px;
    }
  }

  .openInfo {
    width: 90%;
    max-height: 40px;
    overflow: hidden;
    // transition: all 1s linear;
  }
  .newClass {
    width: 90%;
    max-height: 400px;
    overflow: none;
    transition: all 1s linear;
  }
  /deep/ .el-radio-button__inner {
    border: 1px solid #fff !important;
    padding: 9px 10px;
  }
  /deep/ .el-radio-button__inner:hover {
    color: #17757a;
  }
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background-color: #fff;
    color: #17757a;
    border: 1px solid #17757a !important;
    box-shadow: none;
  }
  /deep/ .el-radio-button.is-checked .el-radio-button__inner {
    box-shadow: none;
  }

  .CascaderArea {
    /deep/ .el-input__inner {
      border: 1px solid #17757a;
      color: #17757a;
      height: 34px;
      line-height: 34px;
    }
  }
  /deep/ .el-image__inner {
    border-radius: 5px;
  }
  .case_center_seach {
    text-align: right;
    /deep/ .input-with-select {
      width: 320px;
      margin-right: 25px;
    }
    /deep/ .el-button {
      border-radius: 0 4px 4px 0;
      height: 40px;
    }

    /deep/ .el-button--default {
      background-color: #17757a;

      i {
        color: #fff;
      }
    }
  }
}
/deep/ .el-form-item {
  margin-bottom: 5px !important;
}

/* 媒体查询：自适应 */
// 1680x1050 (1680x889)
@media (max-width: 1682px) and (max-height: 890px) {
  .container {
    max-height: 81vh !important;
  }
}

// 1600x900 (1600x739)
@media (max-width: 1602px) and (max-height: 740px) {
  .container {
    max-height: 78vh !important;
  }
}

// 1366x768 (1366x607)
@media (max-width: 1368px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
  }
}

// 1280x960 (1280x799)
@media (max-width: 1282px) and (max-height: 800px) {
  .container {
    max-height: 80vh !important;
  }
}

// 1280x800 (1280x639)
@media (max-width: 1282px) and (max-height: 640px) {
  .container {
    max-height: 74vh !important;
  }
}

// 1280x768 (1280x607)
@media (max-width: 1282px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
  }
}

// 1280x720 (1280x599)
@media (max-width: 1282px) and (max-height: 600px) {
  .container {
    max-height: 71vh !important;
  }
}

// 1280x600 (1280x439)
@media (max-width: 1282px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
  }
}

// 1152x864 (1152x703)
@media (max-width: 1153px) and (max-height: 704px) {
  .container {
    max-height: 77vh !important;
  }
}

// 1024x768 (1024x607)
@media (max-width: 1025px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
  }
}

// 800x600 (800x439)
@media (max-width: 801px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
  }
}
</style>
